import React, { useState, useEffect } from 'react';

const WEDDING_DATE = new Date('2026-10-30T15:00:00-05:00');

function pad(n) {
  return String(n).padStart(2, '0');
}

export default function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const calc = () => {
      const diff = WEDDING_DATE - Date.now();
      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setTimeLeft({ days, hours, minutes, seconds });
    };
    calc();
    const id = setInterval(calc, 1000);
    return () => clearInterval(id);
  }, []);

  if (!timeLeft) return null;

  const units = [
    { value: timeLeft.days,    label: 'Days' },
    { value: timeLeft.hours,   label: 'Hours' },
    { value: timeLeft.minutes, label: 'Min' },
    { value: timeLeft.seconds, label: 'Sec' },
  ];

  return (
    <div className="home-countdown">
      <div className="home-countdown-inner">
        <div className="countdown-label">Counting down to the celebration</div>
        <div className="countdown-grid">
          {units.map(({ value, label }) => (
            <div className="countdown-unit" key={label}>
              <div className="countdown-num">{pad(value)}</div>
              <div className="countdown-unit-label">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
